module.exports = __webpack_public_path__ + "static/media/Nasa.3343278d.png";